import { Component, inject } from '@angular/core';
import { MenuItemSaudeTrialExpiradoComponent } from './components/trial-expirado/trial-expirado.component';
import { MenuItemSaudeTrialComponent } from './components/trial/trial.component';
import { TrialService } from 'src/app/services/trial.service';
import { NgIconsModule, provideIcons } from '@ng-icons/core';
import { heroSparklesMini } from '@ng-icons/heroicons/mini';

@Component({
  templateUrl: 'menu-item-saude.component.html',
  selector: 'menu-item-saude',
  imports: [
    MenuItemSaudeTrialExpiradoComponent,
    MenuItemSaudeTrialComponent,
    NgIconsModule,
  ],
  providers: [provideIcons({ heroSparklesMini })],
})
export class MenuItemSaudeComponent {
  private readonly saudeCTAService = inject(TrialService);

  protected readonly isTrialExpirado =
    this.saudeCTAService.getStatus(11) === 'TRIALEXPIRED';
}
